import { useState, useTransition } from 'react';
import { Link } from 'react-router-dom';
import BrandMark from '../components/BrandMark.jsx';
import { useAuth } from '../auth/AuthContext.jsx';
import { api } from '../lib/api.js';

export default function AdminPortal() {
  const { user, logout } = useAuth();
  const [matterId, setMatterId] = useState('');
  const [result, setResult] = useState(null);
  const [pending, startTransition] = useTransition();

  function routeAttorney() {
    startTransition(async () => {
      try {
        const data = await api.post('/server/admin_api/routeAttorney', { matterId });
        setResult(data);
      } catch (err) {
        setResult({ assigned: false, reason: err.message, matterId });
      }
    });
  }

  return (
    <div className="app-shell">
      <header className="app-topbar">
        <div className="topbar-brand">
          <BrandMark size={36} />
          <div>
            <span>Internal Operations</span>
          </div>
        </div>
        <div className="topbar-actions">
          <span className="user-chip">{user?.email}</span>
          <Link className="btn-ghost" to="/settings">
            Settings
          </Link>
          <button type="button" className="btn-ghost" onClick={logout}>
            Sign out
          </button>
        </div>
      </header>
      <main className="app-main narrow">
        <h1>Routing engine</h1>
        <p>Manually invoke autoRouteAttorney for a matter after payment or intake.</p>
        <div className="admin-row">
          <input
            value={matterId}
            onChange={(e) => setMatterId(e.target.value)}
            placeholder="Matter ROWID"
          />
          <button type="button" className="btn-primary" onClick={routeAttorney} disabled={pending || !matterId}>
            {pending ? 'Routing…' : 'Run autoRouteAttorney'}
          </button>
        </div>
        {result ? <pre className="result-block">{JSON.stringify(result, null, 2)}</pre> : null}
      </main>
    </div>
  );
}
